import { Module, Payload } from 'vuex'

export interface Profile {
  username: string
  email?: string
}

export interface RegistrationData extends Profile {
  password: string
  password_confirmation: string
  is_patient_account?: boolean
}

export interface Credentials {
  login: string
  password: string
}

export interface PasswordRepeat {
  password: string[]
  password_confirmation: string[]
}

export interface ModuleState {
  currentUser?: Profile
  registrationErrors: object
  loginFailed?: boolean
  authToken?: string
}

export type RootState = any

export const types: {
  mutations: {
    SetAuthToken: string
    SetRegistrationErrors: string
    SetCurrentUser: string
    SignalFailedLogin: string
  }
  actions: {
    Register: string
    Login: string
  }
} = {
  actions: {
    Login: 'LOGIN',
    Register: 'REGISTER',
  },
  mutations: {
    SetAuthToken: 'SET_AUTH_TOKEN',
    SetCurrentUser: 'SET_CURRENT_USER',
    SetRegistrationErrors: 'SET_REGISTRATION_ERRORS',
    SignalFailedLogin: 'SIGNAL_FAILED_LOGIN',
  },
}

export namespace params {
  export namespace actions {
    export interface Register extends Payload {
      profile: RegistrationData
    }

    export interface Login extends Payload {
      credentials: Credentials
    }
  }

  export namespace mutations {
    export interface SetCurrentUser extends Payload {
      user: Profile
    }

    export interface SetAuthToken extends Payload {
      authToken: string
    }

    export interface SetRegistrationErrors extends Payload {
      errors: object
    }

    export interface SignalFailedLogin extends Payload {}
  }
}
